import { FilterPayload } from "@/types";
import { useRouter, useSearchParams } from "next/navigation";

export function useFilter() {
  const router = useRouter();
  const searchParams = useSearchParams();

  const updateFilters = (payload: FilterPayload) => {
    const params = new URLSearchParams(searchParams.toString());

    Object.entries(payload).forEach(([key, value]) => {
      if (
        value === undefined ||
        value === null ||
        value === "all" ||
        value === "" ||
        value === "off"
      ) {
        params.delete(key);
      } else {
        params.set(key, String(value));
      }
    });

    router.push(`?${params.toString()}`, { scroll: false });
  };

  return { updateFilters };
}
